import { Shimmer } from '@soteria/design-system-ve';

import * as shimmerStyles from '../shared/shimmer.css';

import * as denseStyles from './InformationDenseLayout.css';
import * as styles from './styles';

/**
 * Loading state component for the information-dense header layout
 * Matches the structure of the main component with shimmer effects
 */
export function renderLoadingState(): React.JSX.Element {
  return (
    <div className={styles.heroSection}>
      {/* Gradient Overlay */}
      <div className={styles.heroOverlay} />

      <div className={styles.heroContent}>
        {/* Left Column - Community Image Shimmer */}
        <div className={styles.heroImageContainer}>
          <Shimmer className={shimmerStyles.shimmerImage} />
        </div>

        {/* Right Column - Session Details Shimmer */}
        <div className={styles.heroContentRight}>
          {/* Session Title Shimmer */}
          <Shimmer className={shimmerStyles.shimmerTitle} />

          {/* Session Description Shimmer */}
          <Shimmer className={shimmerStyles.shimmerLargeValue} />

          {/* Badge and Progress Section Shimmer */}
          <div className={denseStyles.badgeAndProgressSection}>
            {/* Applied Filters Header Shimmer */}
            <div>
              <Shimmer className={shimmerStyles.shimmerSectionTitle} />

              {/* Badge Groups Container Shimmer */}
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', alignItems: 'center', marginTop: '8px' }}>
                {[1, 2, 3, 4].map(index => (
                  <div key={`badge-group-${index}`} className={denseStyles.badgeGroup}>
                    <Shimmer className={shimmerStyles.shimmerLabel} />
                    <div className={denseStyles.compactBadgeList}>
                      <Shimmer className={shimmerStyles.shimmerBadge} />
                      {index <= 2 && <Shimmer className={shimmerStyles.shimmerBadge} />}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Status Indicator */}
            <div className={denseStyles.inlineProgressSection}>
              <div className={denseStyles.statusIndicator}>
                <Shimmer className={shimmerStyles.shimmerLabel} />
                <Shimmer className={shimmerStyles.shimmerBadge} />
              </div>
            </div>
          </div>

          {/* Two-Column Details Grid Shimmer - Sample Parameters panel hidden */}
          <div className={denseStyles.detailsGrid}>
            {/* Two panels with composition bars - Sample Parameters panel hidden */}
            {[1, 2].map(panelIndex => (
              <div key={`panel-${panelIndex}`} className={denseStyles.detailsPanel}>
                <div className={denseStyles.detailsPanelHeader}>
                  <Shimmer className={shimmerStyles.shimmerSectionTitle} />
                  <Shimmer className={shimmerStyles.shimmerSmallValue} />
                </div>

                <div className={denseStyles.detailsPanelContent}>
                  {/* Composition bars using structured CSS classes */}
                  {Array.from({ length: panelIndex === 1 ? 4 : 2 }, (_, i) => (
                    <div key={`bar-${i}`} className={shimmerStyles.shimmerCompositionRow}>
                      <Shimmer className={shimmerStyles.shimmerDot} />
                      <Shimmer className={shimmerStyles.shimmerLabel} />
                      <Shimmer className={shimmerStyles.shimmerTrack} />
                      <Shimmer className={shimmerStyles.shimmerValue} />
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Session Info Footnote Shimmer */}
          <div className={denseStyles.sessionFootnote}>
            <Shimmer className={shimmerStyles.shimmerTitle} />
          </div>

          {/* Action Buttons Section Shimmer */}
          <div className={denseStyles.actionsContainer}>
            <Shimmer className={shimmerStyles.shimmerButton} />
          </div>
        </div>
      </div>
    </div>
  );
}
